import {
	Card,
	CardGroup,
	Cell,
	GridContainer,
	NotFound,
	PreloaderContainer,
} from '../styles';
import { FC, Fragment } from 'react';
import { GridRowsProps } from '../types';
import { withPreloader } from 'shared/ui/spinner';
import { GridView } from './gridView';
import { Typography } from 'shared/ui/typography';
import { useDebounceCallback } from 'shared/lib/debounce';

export const GridRows: FC<GridRowsProps> = ({
	tableRows,
	onClickOnCard,
	onScrollEnd,
	columnCount,
	selectedRowId = undefined,
	isLoadingBottom,
	gridSettings = {
		moreSpaceForLastColumn: true,
		columnSize: 1,
		trackSize: 3,
	},
	gridStyles = {
		rowsHeight: '',
		rowsPadding: '',
		rowHeight: '',
		rowCardColor: '',
		rowPadding: '',
		rowCorners: '',
		rowMargin: '',
	},
	specificColumnSizes,
	notFoundText = 'К сожалению мы не нашли информацию по заданным фильтрам',
}) => {
  const InView = withPreloader(GridView, PreloaderContainer);

	const debounceClick = useDebounceCallback((id: number) => {
		onClickOnCard?.(id);
	}, 300);

	const handleClickByRowCard = (id: number) => () => {
		debounceClick(id);
	};

	return (
		<>
			{!tableRows.length && (
				<NotFound>
					<Typography>{notFoundText}</Typography>
				</NotFound>
			)}
			{tableRows.map((tableRow, tableRowId) => (
				<Fragment key={tableRowId}>
					{tableRow.header}
					{tableRow.rows.map((row, tableRowIndex) => (
						<CardGroup key={tableRowIndex}>
							{row.header}
							{row.cells.map((cell, rowIndex) => (
								<Card
									onClick={handleClickByRowCard(cell.id)}
									key={rowIndex}
									$selected={selectedRowId === cell.id}
									$bgColor={gridStyles.rowCardColor}
									$margin={gridStyles.rowMargin || '0px'}
									$borderRadius={
										gridStyles.rowCorners || '0px'
									}
									$bordered={(rowIndex !== row.cells.length - 1).toString()}
								>
									<GridContainer
										$columns={
											gridSettings.moreSpaceForLastColumn
												? columnCount - 1
												: columnCount
										}
										$columnSize={gridSettings.columnSize}
										$trackSize={gridSettings.trackSize}
										$specificColumnSizes={
											specificColumnSizes
										}
										$padding={gridStyles.rowPadding}
										$height={gridStyles.rowHeight}
									>
										{cell.fields.map((cell, cellIndex) => (
											<Cell key={cellIndex}>{cell}</Cell>
										))}
									</GridContainer>
								</Card>
							))}
						</CardGroup>
					))}
				</Fragment>
			))}

			<InView
				isLoading={isLoadingBottom}
				onScrollEnd={onScrollEnd}
				error={undefined}
			/>
		</>
	);
};
